import fmDate from 'utils/fmDate';

export const mapUserVolumesParamsToRequestPayload = (data) => {
  const { dateFrom, dateTo, size } = data;
  return {
    from: fmDate(dateFrom).toISOString(),
    to: fmDate(dateTo).toISOString(),
    size,
  };
};

export const mapActiveUsersParamsToRequestPayload = (data) => {
  const { dateFrom, dateTo } = data;
  return {
    dateFrom: fmDate(dateFrom).toISOString(),
    dateTo: fmDate(dateTo).toISOString(),
  };
};

export const mapNetDepositParamsToRequestPayload = (data) => {
  const { dateFrom, dateTo } = data;
  return {
    dateFrom: fmDate(dateFrom).toISOString(),
    dateTo: fmDate(dateTo).toISOString(),
  };
};

export const mapMarketingChannelsParamsToRequestPayload = (data) => {
  const { dateFrom, dateTo, accountType = 'default', groupBy = 'source' } = data;
  return {
    dateFrom: fmDate(dateFrom).toISOString(),
    dateTo: fmDate(dateTo).toISOString(),
    type: accountType,
    groupBy,
  };
};
